export default {
    apiUrl: 'https://appreciate-ephemeral-link.pacewisdom.in/v1',
    emailApiUrl:'https://appreciate-email-unsubscribe-uat.pacewisdom.in/v1',
    secretKey: "fVBRkkXRM2hNnGJj"
}
